import DropdownOptionsMenu from 'global/components/forms/elements/DropdownOptionsMenu';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _, { sortBy } from 'lodash';
import { createScheduleTypes } from 'projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { _seedSortTypes, usePlayoffInfo } from 'projectSpecific/sports/useHelpers/usePlayoffInfo';
import { useContext, useEffect, useReducer, useState, useMemo } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import MenuSidebars from '../../../../global/sidebars/MenuSidebars';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { sportsHelpers } from '../../cnr/reducers/reducerHelpers/sportsHelpers';
import { CreatePlayoffContext } from '../CreatePlayoff';
import CreateSports, { CreateSportsContext } from '../CreateSports';
import { getSectionColor } from '../sectionColors';
import TeamSquares from 'projectSpecific/sports/elements/teams/TeamSquares';
import SeedingsLegend from 'projectSpecific/sports/elements/standings/SeedingsLegend';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import { useSportsSeason } from 'projectSpecific/sports/useHelpers/useSportsSeason';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import { currentHelpers } from 'global/redirection/current';
import { _currentUserIdProp } from 'global/cnr/reducers/AppUserReducer';
import { sportsShowTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer';
import { TeamOpps } from 'projectSpecific/sports/elements/teams/TeamOpps';
import { sportsEloHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/eloInfo';

const sidebarType = 'createSeeds'

export const seedTypes = {
  playoff: 'playoff',
  tournament: 'tournament',
  season: 'season',
}

const CreateSeeds = (props) => {

  const { createScheduleType, handleSelectedTeam, selectedSeededTeam } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers, sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, teams_info: teams_info_ss, details_info, currentSeason_info } = sportsSeason_state ?? {}
  const { matches_combined: matches } = matches_info ?? {}
  const { teams } = teams_info_ss ?? {}
  const { details, playoffQualifyCounts, sectionPlayoffTeams } = details_info ?? {}
  const { hideElo, hideRpi, hidePpm, allowRankingsUpdate } = details ?? {}

  const auid = currentHelpers.storageItem_get(_currentUserIdProp);

  const { _sportsModeSport } = currentSeason_info ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { teams_info } = createSports_state ?? {}
  const { selected: teams_selected } = teams_info ?? {}

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { playoffLevel, playoffLevelTeams } = playoff_info ?? {}
  const teams_playoffGroup = playoffLevelTeams?.[playoffLevel]

  const { getUniqueMatchDates } = useSportsSeason()

  const uniqueMatchDates = useMemo(() => {
    return getUniqueMatchDates()
  }, [])

  const { createTeamsWithSeeds, sortTeamSeeds, sortPlayoffSeeds } = usePlayoffInfo({})

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit } = sidebar_handlers ?? {}

  const { ms_playoffGroups } = sidebar_items ?? {}
  const { selected: selected_pg } = ms_playoffGroups ?? {}
  const { item: item_playoffLevel } = selected_pg ?? {}

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }

  // local states
  const [currentDateIndex, setCurrentDateIndex] = useState(0);
  const [levels, setLevels] = useState()
  const [seasonLevelTeams, setSeasonLevelTeams] = useState()
  const [teamsReordered, setTeamsReordered] = useState()
  const [seasonDynamicLevelTeams, setSeasonDynamicLevelTeams] = useState({})
  const [selectedTeams, setSelectedTeams] = useState({ team: null, oppTeam: null })
  const [showTeams, setShowTeams] = useState()
  const [sortType, setSortType] = useState()
  const [showHelp, setShowHelp] = useState()
  const [timerOn, setTimerOn] = useState()
  const [pto, setPto] = useState()
  const [showPlayoff, setShowPlayoff] = useState()

  // console.clear()
  // console.group('Create Seeds')
  // console.log('seasonLevelTeams', seasonLevelTeams)
  // console.log('seasonDynamicLevelTeams', seasonDynamicLevelTeams)
  // console.log('levels', levels)
  // console.log('sortType', sortType)
  // console.groupEnd()

  const caption = useMemo(() => {
    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        return 'Playoff Seeds'
      case createScheduleTypes.season:
        return `Rankings`
      default:
      // nothing
    }
  }, [sortType, createScheduleType])

  const saveSeasonLevelTeams = (opts) => {
    if (!seasonLevelTeams) return;
    const result = _.map(seasonLevelTeams?.[item_playoffLevel], obj => _.pick(obj, ['_itemKey', 'name']));
    console.log('seasonLevelTeams', auid, item_playoffLevel, result)
  }

  const handleSortType = (opts) => setSortType(opts?.sortBy)
  // const handleShowTeams = () => setShowTeams(!showTeams)
  const handleSelectTeams = (team, oppTeam) => setSelectedTeams({ team, oppTeam })
  const handleShowHelp = () => setShowHelp(!showHelp)
  const handleShowPlayoff = () => setShowPlayoff(!showPlayoff)
  const handlePto = () => setPto(!pto)
  const handleTimerOn = () => {
    if (timerOn) {
      setCurrentDateIndex(0)
    }
    setTimerOn(!timerOn)
  }

  const teams_seasonGroup = useMemo(() => {
    if (_.isEmpty(seasonDynamicLevelTeams) && _.isEmpty(seasonLevelTeams)) return;
    const tsg = timerOn ? seasonDynamicLevelTeams?.[item_playoffLevel] : seasonLevelTeams?.[item_playoffLevel]
    if (pto) {
      const tsg_pt = _.pickBy(tsg, team => team?.record?.playoffTeam === true);
      return tsg_pt
    }
    return tsg
  }, [item_playoffLevel, seasonLevelTeams, seasonDynamicLevelTeams, pto])

  useEffect(() => {
    if (!uniqueMatchDates || !uniqueMatchDates.length) return;
    if (!timerOn) return;

    const interval = setInterval(() => {
      setCurrentDateIndex(prev => {
        if (prev >= uniqueMatchDates.length - 1) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 2500); // 👈 speed control

    return () => clearInterval(interval);
  }, [uniqueMatchDates, timerOn]);

  useEffect(() => {
    // update the playoffLevelTeams on init
    if (_.isEmpty(teams)) return;
    const teamsByLevel = _.groupBy(teams, 'levels')
    setSeasonLevelTeams(teamsByLevel)
    if (teamsByLevel) {
      const _levels = _.keys(teamsByLevel).sort().reverse()
      setLevels(_levels)
      setInit({ smt: sidebarMenuTypes.one, items: _levels, currents, as: 'playoffGroups', ..._initProps })
      setSortType(_seedSortTypes.elo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams]); //teams

  useEffect(() => {
    // update the playoffLevelTeams on init
    if (_.isEmpty(playoffLevelTeams)) return;
    setLevels(_.keys(playoffLevelTeams).sort().reverse())
    const _playoffLevelTeams = {}
    _.forEach(playoffLevelTeams, (_playoffGroup, pltk) => {
      const _playoffGroup_sorted = _.orderBy(_playoffGroup, ['owp', 'swp'], ['desc', 'desc']);
      _playoffLevelTeams[pltk] = _playoffGroup_sorted
    })
    createPlayoff_handlers.handleSet_playoffLevelTeams(_playoffLevelTeams)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []); // playoffLevelTeams

  // update the seasonLevelTeams based on the current match date
  useEffect(() => {
    if (!uniqueMatchDates[currentDateIndex]) return;
    if (!timerOn) return;
    const _teams = _.cloneDeep(teams)
    const ssi = sportsHelpers.ammendTeams(_teams, matches, null, _sportsModeSport, playoffQualifyCounts, sectionPlayoffTeams, uniqueMatchDates[currentDateIndex])
    const teamsByLevel = _.groupBy(ssi.teams, 'levels')
    const _teams_sorted = sortTeamSeeds({ levelTeams: teamsByLevel, levelKey: item_playoffLevel, sortBy: sortType })
    handleReorder(_teams_sorted)
  }, [currentDateIndex]);

  useEffect(() => {
    if (_.isEmpty(teams_selected)) return;
    const _seededTeams = createTeamsWithSeeds(teams_selected)
    createPlayoff_handlers.handleUpdate_seededTeams(_seededTeams)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams_selected]); // teams_selected

  useEffect(() => {
    if (_.isEmpty(playoffLevelTeams) || !playoffLevel) return;
    const _playoffGroup = playoffLevelTeams[playoffLevel]
    createPlayoff_handlers.handleSet_team_playoffGroup(playoffLevel, _playoffGroup)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []); // item_playoffLevel, playoffLevelTeams

  useEffect(() => {
    let _teams_sorted = []
    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        if (!playoffLevelTeams) return;
        _teams_sorted = sortPlayoffSeeds({ levelTeams: playoffLevelTeams, levelKey: playoffLevel, sortBy: sortType })
        createPlayoff_handlers.handleSet_team_playoffGroup(playoffLevel, _teams_sorted)
        break;

      case createScheduleTypes.season:
        if (!seasonLevelTeams) return;
        _teams_sorted = sortTeamSeeds({ levelTeams: seasonLevelTeams, levelKey: item_playoffLevel, sortBy: sortType })
        break;
      default:
      // nothing
    }
    handleReorder(_teams_sorted)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [sortType]); // sortType, item_playoffLevel

  /**
   * handles the sorting of the teams
   * @param {*} items 
   */
  const handleReorder = (items) => {

    _.forEach(items, (dataItem, index) => {
      dataItem.position = index
      dataItem.seed = index + 1
    })

    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        if (!playoffLevelTeams) return;
        const _playoffLevelTeams = _.cloneDeep(playoffLevelTeams)
        _playoffLevelTeams[playoffLevel] = items
        createPlayoff_handlers.handleAmmend_playoffSeededTeams(_playoffLevelTeams)
        break;

      case createScheduleTypes.season:
        if (!seasonLevelTeams) return;
        const _seasonLevelTeams = _.cloneDeep(seasonLevelTeams)
        _seasonLevelTeams[item_playoffLevel] = items
        if (timerOn) {
          setSeasonDynamicLevelTeams(_seasonLevelTeams)
        } else {
          setSeasonLevelTeams(_seasonLevelTeams)
        }
        break;
      default:
      // nothing
    }
  }

  // button triggering the team sort
  const btn_sort = (sst) => {
    return { caption: _.toUpper(sst), oc: handleSortType, color: 'blue', fl: true, icon: 'arrow right', opts: { sortBy: sst } }
  }

  // group of buttons to handle the sort
  const btns_sort = () => {
    const btns = []
    !hideElo && btns.push(btn_sort(_seedSortTypes.elo))
    btns.push(btn_sort(_seedSortTypes.owp))
    !hideElo && btns.push(btn_sort(_seedSortTypes.pd))
    !hidePpm && btns.push(btn_sort(_seedSortTypes.ppm))
    !hideRpi && btns.push(btn_sort(_seedSortTypes.rpi))
    !hideElo && btns.push(btn_sort(_seedSortTypes.sos))
    btns.push(btn_sort(_seedSortTypes.sr))
    return btns
  }

  // const icon_showTeams = (oc) => <Label color={showTeams ? 'blue' : 'black'} onClick={() => { oc && oc() }}><Icon name={showTeams ? 'check circle' : 'circle outline'} />{'Results'}</Label>
  const icon_showHelp = (oc) => <Icon bordered name={'help circle'} color={'yellow'} onClick={() => { oc && oc() }} />
  // const icon_pto = (oc) => <Label style={{ marginRight: '.5em' }} color={pto ? 'green' : 'grey'} title={'Playoff Teams Only'} onClick={() => { oc && oc() }}>{'PTO'}</Label>
  const icon_create = (oc) => <Icon bordered name={'wizard'} color={'blue'} onClick={() => { oc && oc() }} />

  const icon_timer = (oc) => {
    if (timerOn) {
      return <Label color={'blue'} onClick={() => { oc && oc() }}><Icon name={'clock outline'} />{uniqueMatchDates?.[currentDateIndex]}</Label>
    } else {
      return <Icon name={'clock outline'} bordered onClick={() => { oc && oc() }} />
    }
  }

  const header_seed = useMemo(() => {
    const icons = []
    const oc = (item) => {
      setSortType(item)
    }

    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        // icons.push(icon_showTeams(handleShowTeams))
        break;
      default:
        icons.push(icon_create(handleShowPlayoff))
        icons.push(icon_timer(handleTimerOn))
      // icons.push(icon_pto(handlePto))
      // nothing
    }

    return <div className='header-flex'>
      <div>{caption}</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {icons}
        <DropdownOptionsMenu
          menuButtons={btns_sort()}
          caption={`Sort By ${sortType ? ': ' + _.upperCase(sortType) : ''}`}
          iconn={icon_showHelp(handleShowHelp)}
          color={'blue'}
          direction={'left'}
          upward={false}
          ignoreCaption={true}
          asIms={true}
        />
      </div>
    </div>
  }, [createScheduleType, showTeams, sortType, timerOn, currentDateIndex, pto])

  const handleItemClick = (item) => {
    const teamIndex = _.findIndex(teams_seasonGroup, { _itemKey: item._itemKey })
    const nextIndex = teamIndex + 1
    const t1 = teams_seasonGroup[teamIndex]
    const t2 = teams_seasonGroup[nextIndex]
    handleSelectedTeam && handleSelectedTeam(item)
    handleSelectTeams(t1, t2)
  }

  const ims = (mis, fnAlt, fnSub, hs) => <ItemMenuSquares
    menuItems={mis}
    imsType={_imsTypes.inline}
    fn_sort={fnSort}
    fn_altContent={fnAlt}
    // fn_subContent={fnSub}
    onClick={handleItemClick}
    onSort={hs}
    activeItem={selectedSeededTeam?._itemKey}
    sortProp={'seed'}
  />

  const playoffGroupContainer = () => {
    if (showTeams) {
      return <TeamSquares playoffLevel={playoffLevel} teams={teams_playoffGroup} />
    } else {
      const hs = (list) => handleReorder(list)
      const dataItems = _.sortBy(teams_playoffGroup, 'seed')
      // const zzz = sportsEloHelpers.adjustSeedsByHeadToHead({ teamsInOrder: teams_playoffGroup, matches })
      // console.log(zzz)
      return ims(dataItems, fnAltContent_playoff, fnSubContent_playoff, hs)
    }
  }

  const seasonGroupContainer = () => {
    if (showTeams) {
      return <TeamSquares playoffLevel={playoffLevel} teams={teams_playoffGroup} />
    } else {
      const hs = (list) => {
        handleReorder(list)
        setTeamsReordered(true)
      }
      return ims(teams_seasonGroup, fnAltContent_season, null, hs)
    }
  }

  const playoffGroupWrapper = () => <Wrapper
    header={header_seed}
    content={playoffGroupContainer()}
    wrapperType={wrapperTypes.paddedContent}
  />

  const footer_save = () => {
    return <UiSaveButtons
      save={{ oc: saveSeasonLevelTeams, caption: `Save ${item_playoffLevel} Teams` }}
    />
  }

  const seasonGroupWrapper = () => <Wrapper
    header={header_seed}
    content={seasonGroupContainer()}
    footer={allowRankingsUpdate && teamsReordered && footer_save()}
    wrapperType={wrapperTypes.paddedContent}
  />

  const fnSort = (item) => {
    const ds = []
    const { seed } = item ?? {}
    ds.push(<Label className='sqr-box-sort' color='blue' size='tiny'>{seed}</Label>)
    return ds
  }

  const lbls = (ds, sections, record, item) => {
    const { owp, swp, ppm, sectionRank, display, eloInfo, rpiInfo, playoffTeam } = record ?? {}
    const cs = getSectionColor(sections)
    const _section = sections ? sections.replace('section', '') : sections
    switch (createScheduleType) {
      case createScheduleTypes.season:
        ds.push(<Label size='tiny'><Icon name={playoffTeam ? 'check circle' : 'ban'} color={playoffTeam ? 'green' : 'grey'} />{display} </Label>)
        break;
      default:
      // nothing
    }
    try {

      const safeOwp = Number(owp);
      const safeSwp = Number(swp);
      const safePpm = Number(ppm);

      switch (sortType) {
        case _seedSortTypes.elo:
          ds.push(<Label size='tiny'>{`ELO: ${eloInfo?.elo}`}</Label>)
          break;
        case _seedSortTypes.rpi:
          ds.push(<Label size='tiny'>{`RPI: ${rpiInfo?.rpi}`}</Label>)
          break;
        case _seedSortTypes.owp:
          ds.push(<Label size='tiny'>
            {`OWP ${(Number.isFinite(safeOwp) ? safeOwp : 0).toFixed(2)} | ${(
              Number.isFinite(safeSwp) ? safeSwp : 0
            ).toFixed(2)} SWP`}
          </Label>)
          break;
        case _seedSortTypes.ppm:
          ds.push(
            <Label size='tiny'>
              {`PPM: ${Number.isFinite(safePpm) ? safePpm.toFixed(2) : '0.00'}`}
            </Label>
          );
          break;
        case _seedSortTypes.sos:
          ds.push(<Label size='tiny'>{`SOS: ${eloInfo?.strengthOfSchedule}`}</Label>)
          break;
        case _seedSortTypes.pd:
          ds.push(<Label size='tiny'>{`PD: ${eloInfo?.performanceDelta}`}</Label>)
          break;
        case _seedSortTypes.sr:
          break;
      }
    } catch (error) {

    }

    ds.push(<Label size='tiny' style={{ border: `1px solid var(--sem-${cs})` }}  >{`${_section} - ${sectionRank}`}</Label>)
  }

  const fnAltContent_playoff = (item) => {
    const ds = []
    const { sections, badSeed, record } = item ?? {}
    const sc = getSectionColor(sections)
    badSeed && ds.push(<Icon name={'ban'} color={sc || 'red'} />)
    lbls(ds, sections, record || item, item)
    return ds
  }

  const fnSubContent_playoff = (item) => {
    if (!selectedSeededTeam) return;
    if (selectedSeededTeam?._itemKey !== item?._itemKey) return null;
    const { seed } = item
    const _seed = seed + 1
    const oppTeam = _.find(teams_playoffGroup, { seed: _seed })
    return <TeamOpps team={item} oppTeam={oppTeam} noMid={true} excludeSection={true} />
  }

  const fnAltContent_season = (item) => {
    const ds = []
    const { record, sections } = item ?? {}
    if (!record) return;
    lbls(ds, sections, record, item)
    return ds
  }

  const menuSidebars = () => <MenuSidebars
    sidebarType={sidebarType}
    sidebar_items={sidebar_items}
    sidebar_handlers={sidebar_handlers}
    content={seasonLevelTeams ? seasonGroupWrapper() : <div></div>}
    dimmed={dimmed}
  />

  if (showHelp) {
    return <FullPageWrapper
      content={<SeedingsLegend sortType={sortType} />}
      handleCancel={handleShowHelp}
      css={{ container: 'app-dark-mode' }}
    ></FullPageWrapper>
  }

  if (showPlayoff) {
    return <CreateSports
      fromDashboard={false}
      fromApp={true}
      subActionType={sportsShowTypes.createPlayoff}
      latestSeason={'2026'}
      handleCancel={handleShowPlayoff}
      fromSeed={true}
    />
  }

  switch (createScheduleType) {
    case createScheduleTypes.playoff:
      if (playoffLevelTeams && levels && ms_playoffGroups && ms_playoffGroups.items) {
        return teams_playoffGroup ? playoffGroupWrapper() : <div></div>
      }
    case createScheduleTypes.season:
      return menuSidebars()
    case createScheduleTypes.crossover:
      return <div>{createScheduleType}</div>
    default:
      return <div>{createScheduleType}</div>
  }

}

export default CreateSeeds